// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"16":"d41dbb2d","49":"2e42bb46","61":"8afc5374","714":"6b269176"}[chunkId] + ".css";
};